



























import Vue from 'vue'

interface WizardStep {
  id: number;
  label: string;
  icon: string;
  enabled: boolean;
}

export default Vue.extend({
  name: 'AuctionWizardHeader',
  props: {
    currentStep: {
      type: Number,
      required: true
    },
    lastValidatedStep: {
      type: Number,
      required: true
    }
  },
  computed: {
    wizardSteps (): WizardStep[] {
      return [
        { id: 1, label: 'persoais', icon: 'user', enabled: this.lastValidatedStep >= 1 },
        { id: 2, label: 'declaracions', icon: 'file', enabled: this.lastValidatedStep >= 2 }
      ]
    }
  },
  watch: {
    currentStep (newValue: number): void {
      this.wizardSteps.forEach(step => {
        if (step.id <= newValue) {
          step.enabled = true
        }
      })
    }
  },
  methods: {
    onTabClicked (id: number) {
      const step = this.wizardSteps.find(wizard => wizard.id === id)
      if (step && step.enabled) {
        this.$emit('step-changed', id)
      }
    }
  }
})
